/*
 * File: d:\projects\AutoFiFront\src\Content\Faq\FaqBox\FaqBox.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday April 18th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday April 18th 2023 5:14:57 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styles from "Content/Faq/FaqBox/FaqBox.module.css";
import translator from 'MultiLanguage/TranslationWrapper';
import CollapseBox from 'Content/CollapseBox/CollapseBox';

type FaqBoxProps = {
    title: string,
    part: {question: string, response: string[]}[]
};

function FaqBox(props:FaqBoxProps) {
    return (
        <div className={`${styles.box}`}>
            <h2 className={`${styles.title}`}>
                {translator.decode(`faq.${props.title}`)}
            </h2>
            <div className={`${styles.resp}`}>
                {
                    props.part.map((item,index) => { return <CollapseBox key={`faq${index}`} question={item.question} response={item.response} />})
                }
            </div>
        </div>
    );
};

export default FaqBox;
